var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 系统信息 "),_c('div',{staticStyle:{"margin-top":"50px"}},[_vm._v("到期日期："+_vm._s(_vm.expiringDate))]),_c('div',{staticStyle:{"margin-top":"50px"}},[_vm._v("版本信息："+_vm._s(_vm.version))])])}
var staticRenderFns = []

export { render, staticRenderFns }